/**
 * "We need your card's billing address to calculate tax" (TMMAPP-0119 item 11): the served
 * `GET /me/billing.taxLocationRequired` banner, with Update card. It is announced only when it
 * arrives while the page is open (§34 item 11); present on load, it is a plain warning.
 */
import { useState } from 'react';
import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function TaxLocationBanner({
  shown,
  onUpdateCard,
}: {
  shown: boolean;
  onUpdateCard: () => void;
}) {
  const { t } = useTranslation();
  const [shownOnLoad] = useState(shown);
  if (!shown) return null;
  return (
    <Alert
      severity="warning"
      data-tax-location-required=""
      role={shownOnLoad ? 'note' : 'alert'}
      action={
        <Button color="inherit" size="small" onClick={onUpdateCard}>
          {t('aiWallet.updateCard')}
        </Button>
      }
    >
      {t('billing.taxLocationRequired')}
    </Alert>
  );
}
